import {
    SYSTEM_SUBMIT_SALARYRANGE_BEGIN,
    SYSTEM_SUBMIT_SALARYRANGE_SUCCESS,
    SYSTEM_SUBMIT_SALARYRANGE_FAILURE,
    SYSTEM_SUBMIT_SALARYRANGE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitSalaryRange(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_SALARYRANGE_BEGIN,
      });
  
      let apiurl = '/api/b/salaryRange/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/salaryRange/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_SALARYRANGE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_SALARYRANGE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitSalaryRangeError() {
    return {
      type: SYSTEM_SUBMIT_SALARYRANGE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_SALARYRANGE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitSalaryRangePending: true,
          submitSalaryRangeError: null,
        };
  
      case SYSTEM_SUBMIT_SALARYRANGE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitSalaryRangePending: false,
          submitSalaryRangeError: null,
        };
  
      case SYSTEM_SUBMIT_SALARYRANGE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitSalaryRangePending: false,
          submitSalaryRangeError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_SALARYRANGE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitSalaryRangeError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitSalaryRange.js